/*=========================================================================================
  File Name: moduleTransactionMngGetters.js
  Description: Transaction Module Getters
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 30062020
==========================================================================================*/

export default {}
